import makeStyles from '@mui/styles/makeStyles';

export const titleMarginDragWidthInPixels = 6;

export const useStyles = makeStyles(theme => ({
  dialogPaper: {
    minHeight: '90vh',
    maxHeight: '90vh'
  },
  dialogContentRoot: {
    position: 'relative'
  },
  container: {
    border: `solid thin ${theme.palette.divider}`,
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '24px',
    right: '24px',
    margin: 'auto'
  },
  editorTitles: {
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
    flex: '0 0 auto'
  },
  editorComponent: {
    flex: '1 1 auto'
  },
  modalTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  titleContainer: {
    padding: '5px 6px',
    backgroundColor: theme.palette.background.paper,
    borderBottom: `solid thin ${theme.palette.divider}`
  },
  titleMargin: {
    width: titleMarginDragWidthInPixels,
    borderLeft: `solid thin ${theme.palette.divider}`,
    backgroundImage: `linear-gradient(to ${theme.isDark ? 'left' : 'right'}, ${theme.palette.background.paper} , ${
      theme.palette.divider
    })`,
    position: 'relative',
    cursor: 'col-resize'
  },
  title: {
    fontWeight: '600'
  },
  caption: {
    color: theme.palette.text.main,
    fontSize: '12px'
  },
  captionKgId: {
    color: theme.palette.text.primary,
    fontWeight: '600'
  },
  closeIcon: {
    width: 14,
    height: 14,
    marginLeft: 5,
    cursor: 'pointer',
    '& path': { fill: theme.palette.text.primary },
    '&:hover': { '& path': { fill: '#f44336' } }
  },
  errorContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));
